import React from 'react';
import { CTAButton } from './CTAButton';
export function HeroSection() {
  const handleScrollToInfo = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('que-incluye')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  const handleScrollToBuy = (e: React.MouseEvent<HTMLAnchorElement>) => {
    e.preventDefault();
    document.getElementById('comprar')?.scrollIntoView({
      behavior: 'smooth'
    });
  };
  return <section className="pt-8 pb-8 md:pt-12 md:pb-12 px-4" data-id="element-60">
      <div className="max-w-5xl mx-auto text-center" data-id="element-61">
        <h1 className="text-4xl md:text-6xl font-black mb-6 leading-tight uppercase tracking-tight" data-id="element-62">
          <span className="block text-gray-900" data-id="element-63">Mega Pack</span>
          <span className="block text-orange-500" data-id="element-64">Psicopedagogía</span>
        </h1>

        <div className="relative max-w-md md:max-w-lg mx-auto mb-6" data-id="element-65">
          <a href="https://payments.vantapro.shop/cart/44978652708966:1" className="block cursor-pointer hover:opacity-95 transition-opacity" data-id="element-66">
            <img src="https://cdn.magicpatterns.com/uploads/pa8RpzBm56ZwMGi1Ty4V1w/Diseno_sin_titulo_(6).png" alt="Kit Completo Psicopedagogía Lista" className="w-full h-auto drop-shadow-2xl rounded-xl" data-id="element-67" />
          </a>
        </div>

        <h2 className="text-3xl md:text-4xl font-extrabold text-orange-500 mb-4 uppercase" data-id="element-68">
          6 Tomos + 3 Bonos
        </h2>

        <p className="text-lg md:text-2xl text-gray-700 mb-8 max-w-4xl mx-auto font-medium leading-relaxed" data-id="element-69">
          Recursos listos para usar en consultorio y escuela: evaluación,
          intervención, actividades y sesiones preparadas para TDA/TDAH, TEA,
          Dislexia, Discalculia, Psicomotricidad y socioemocional.
        </p>

        <div className="flex flex-col sm:flex-row items-center justify-center gap-4 mb-8" data-id="element-70">
          <CTAButton text="ADQUIRIR AHORA" className="w-full sm:w-auto" data-id="element-71" />
          <a href="#que-incluye" onClick={handleScrollToInfo} className="w-full sm:w-auto px-8 py-5 text-xl font-bold text-gray-700 bg-gray-100 rounded-lg hover:bg-gray-200 transition-colors text-center border-b-4 border-gray-300" data-id="element-72">
            MÁS INFO
          </a>
        </div>

        <div className="mt-4" data-id="element-73">
          <button onClick={handleScrollToBuy} className="inline-flex items-center gap-2 px-8 py-4 text-lg md:text-xl font-black text-white bg-gradient-to-r from-orange-500 to-amber-500 rounded-full shadow-lg hover:from-orange-600 hover:to-amber-600 hover:shadow-xl hover:scale-105 transition-all duration-200 border-b-4 border-orange-700" data-id="element-74">
            🔥 ¡Quiero organizar mi consultorio ahora!
          </button>
        </div>
      </div>
    </section>;
}